var $ = jQuery = require('jquery');
var Pikaday = require('./pikaday');

angular.module('blc').directive('blcCalendar', blc_calendar_single);
blc_calendar_single.$inject = ['$compile']
function blc_calendar_single($compile) {
  // may be var pixker is the same for all instances;
  controller.$inject = ['$scope'];
  return {
    restrict: 'A',
    scope: true,
    link: link,
    controller: controller
  }
  function controller($scope) {
    return 
    $scope.$watch('quote.dates', function(curr, old) {
      // $scope.picker.setRangeStart(curr[0]);
      // $scope.picker.setRangeEnd(curr[1]);
      $scope.picker.draw(1);
    }, 1);
    $scope.$watch('current_date', function (curr, prev) {
      if (curr===null) return;
      $scope.picker.setMinDate(new Date( curr===0 ? null : $scope.quote.dates[0] ));
      $scope.picker.draw(1);
    });

  }



  function link($scope,elm,attrs) {


    elm.addClass('blc-calendar');
	  if (Modernizr.inputtypes.date && isMobileOs()) {
      const date = $scope.quote.dates[0] ? $scope.quote.dates[0] : new Date()
      var html = elm
                  .clone()
                  .removeAttr('ng-click blc-calendar ng-value')
                  .attr('type','date')
                  .attr('ng-value', "(quote.dates[0] | date:'yyyy-MM-dd':'+0000')")
                  [0].outerHTML 
      var replace = $compile(html)($scope)
      elm.replaceWith(replace)
      replace.on('input', function() {
        const olddate = moment($scope.quote.dates[0] ? $scope.quote.dates[0] : new Date)
        var newdate = moment(this.valueAsNumber).startOf('day').hour(olddate.hour()).minute(olddate.minute())
        $scope.quote.dates[0] = newdate.toDate()
      })
      return
    }
    $scope.picker = new Pikaday({
      numberOfMonths: isMobile() ? 18 : 2,
      minDate: new Date(),
      onOpen:function(){
      },
      onSelect: function (evt) {
        var d = this._d;
        $scope.$apply(function() {
          $scope.quote.dates[$scope.current_date] = d;
          $scope.dates = $scope.quote.dates;

          // $scope.picker.draw(1);
        });
      }
    });
    elm.after($scope.picker.el);
  }

}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/calendar-directive.js
 ** module id = 16
 ** module chunks = 0
 **/